import { getConfigBaseUrl, getConfigGraphBaseUrl } from '../../../services/apiService';
import { getCounterpartyId } from '../../../services/authService';
import { apiCall, createApiThunk, graphqlCall } from '../../../utils/api';
import { print } from 'graphql';
import { getAllCounterpartyQuery } from './counterpartiesQueries';

export const getAllCounterpartyThunk = createApiThunk('GET_ALL_COUNTERPARTY', graphqlCall);
export const createCounterpartyThunk = createApiThunk('CREATE_COUNTERPARTY', apiCall);
export const editCounterpartyThunk = createApiThunk('EDIT_COUNTERPARTY', apiCall);
export const getSelectedCounterpartyThunk = createApiThunk('GET_COUNTERPARTY', apiCall);
export const deleteCounterpartyThunk = createApiThunk('DELETE_COUNTERPARTY', apiCall);

export const getAllCounterparty = () => {
  const url = getConfigGraphBaseUrl();
  const query = print(getAllCounterpartyQuery);
  return function (dispatch: AppDispatch) {
    dispatch(getAllCounterpartyThunk({ url, query }));
  };
};

export const createCounterparty = (data: any) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/counterparty`;
  const method = 'POST';
  return dispatch(createCounterpartyThunk({ url, method, data }));
};

export const editCounterparty = (data: any) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/counterparty`;
  const method = 'PUT';
  return dispatch(editCounterpartyThunk({ url, method, data }));
};

export const getSelectedCounterparty = (id: string) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/counterparty/${id}`;
  return dispatch(getSelectedCounterpartyThunk({ url }));
};

export const deleteCounterparty = (id: string) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/counterparty/${id}`;
  const method = 'DELETE';
  return dispatch(deleteCounterpartyThunk({ url, method }));
};
